import { DataSourcePlotSettings } from "../../../settings/view-objects/plot/data-source-plot-settings";
import { SettingsParser } from "../../settings-parser";

export class DataSourcePlotSettingsParser extends SettingsParser {
  constructor(channelParser, markParser) {
    super();
    this.parsedFieldNames = ["id_dataSource", "channels", "channel", "marks", "mark"];
    this.channelParser = channelParser;
    this.markParser = markParser;
  }

  static createSettings(settings, defaultSettings, channelParser, markParser) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedSettings = {
      id_dataSource: settings.id_dataSource
    };
    if (settings.channels !== undefined) {
      parsedSettings.channels = [];
      SettingsParser.parseChildItems(settings.channels, defaultSettings?.channel, channelParser, channelSettings => {
        channelSettings.id_dataSource = parsedSettings.id_dataSource;
        parsedSettings.channels.push(channelSettings);
      });
    }
    if (settings.marks !== undefined) {
      parsedSettings.marks = [];
      SettingsParser.parseChildItems(settings.marks, defaultSettings?.mark, markParser, markSettings => {
        markSettings.id_dataSource = parsedSettings.id_dataSource;
        parsedSettings.marks.push(markSettings);
      });
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    const parsedSettings = DataSourcePlotSettingsParser.createSettings(settings, defaultSettings, this.channelParser, this.markParser);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new DataSourcePlotSettings(parsedSettings);
  }
}
